export default function isEmailAddress(value) {
    const emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|([0-9]{10})+$/
    if(value.match(emailRegex)) { return true; } 
    return false;
}
